import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { getDecryptedUserFromCookie } from '../utils/getCookie';
import { decryptToken } from '../utils/getToken';

const TermsModal = ({ isOpen, setIsOpen, fetchData, selectedAttribute, isEdit, attributeId, categories }) => {
    const [name, setName] = useState('');
    const [baseName, setBaseName] = useState('');
    const [unit, setUnit] = useState('');
    const [status, setStatus] = useState(null);
    const [type, setType] = useState(null);
     const user = getDecryptedUserFromCookie();
     const urlmain = process.env.REACT_APP_LINK
    const statusOptions = [
        { value: 'Active', label: 'Active' },
        { value: 'Inactive', label: 'Inactive' },
    ];

    const TypeOptions = [
        { value: 'color', label: 'Color' },
        { value: 'size', label: 'Size' },
        { value: 'numbersize', label: 'numbersize' },
        { value: 'unit', label: 'Unit' },
        { value: 'other', label: 'Other' },
    ];
    const token = decryptToken("accessToken") || ""

    useEffect(() => {
        if (isEdit && selectedAttribute) {
            const splitName = selectedAttribute.name?.split(' ');
            const lastWord = splitName?.[splitName.length - 1];
            const unitMatch = categories.find(cat => cat.name === lastWord);
            const inferredBaseName = unitMatch ? splitName.slice(0, -1).join(' ') : selectedAttribute.name;

            setBaseName(inferredBaseName);
            setName(selectedAttribute.name || '');
            setUnit(unitMatch?.name || '');
            setStatus(statusOptions.find(opt => opt.value === selectedAttribute.status));
            setType(TypeOptions.find(opt => opt.value === selectedAttribute.slug));
        } else {
            setBaseName('');
            setName('');
            setStatus(null);
            setType(null);
            setUnit('');
        }
    }, [selectedAttribute, isEdit, categories]);

    console.log(unit)
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const payload = {
                name,
                status: status?.value || '',
                attributeId: attributeId,
                slug: type?.value || "",
                unit: unit,
                user_id: user.main_id,
                user_name: user.full_name
            };

            const url = isEdit
                ? `${urlmain}/terms/single/${selectedAttribute.id}`
                : `${urlmain}/terms/admin1997`;

            const method = isEdit ? 'PUT' : 'POST';

            const response = await fetch(url, {
                method,
                headers: { 'Content-Type': 'application/json',
                     Authorization: `Bearer ${token}`,
                 },
                body: JSON.stringify(payload)
            });

            const res = await response.json();
            if (response.ok) {
                toast.success(isEdit ? "Terms updated" : "Terms created", { position: "top-center", autoClose: 2000 });
                fetchData();
                setIsOpen(false);
            }
        } catch (error) {
            toast.error("Something went wrong", { position: "top-center", autoClose: 2000 });
        }
    };

    if (!isOpen) return null;

    return (
        <div className="custom-modal-overlay" >
            <div className="custom-modal-content" >
                <h2 className="oms-modal-title">{isEdit ? "Edit Terms" : "Terms Details"}</h2>
                <form className="oms-modal-form" onSubmit={handleSubmit}>
                    <div className="oms-form-group">
                        <label>Name</label>
                        <input
                            type="text"
                            value={baseName}
                            onChange={(e) => {
                                const newBase = e.target.value;
                                setBaseName(newBase);
                                if (type?.value === 'unit' && unit) {
                                    setName(`${newBase} ${unit}`);
                                } else {
                                    setName(newBase);
                                }
                            }}
                        />

                    </div>
                    <div className="oms-form-group">
                        <label>Type</label>
                        <Select options={TypeOptions} value={type} onChange={setType} />
                    </div>
                    {
                        type?.value === "unit" ?
                            <div className="oms-form-group">
                                <label>Unit/Params</label>
                                <Select
                                    options={categories.map(cat => ({ label: cat.name, value: cat.name }))}
                                    value={categories.find(cat => cat.name === unit) ? { label: unit, value: unit } : null}
                                    onChange={(e) => {
                                        const newUnit = e.value;
                                        setUnit(newUnit);
                                        setName(`${baseName} ${newUnit}`);
                                    }}
                                />

                            </div> : null
                    }
                    <div className="oms-form-group">
                        <label>Status</label>
                        <Select options={statusOptions} value={status} onChange={setStatus} />
                    </div>

                    <div className="oms-form-actions">
                        <button type="button" onClick={() => setIsOpen(false)}>Cancel</button>
                        <button type="submit">{isEdit ? "Update" : "Submit"}</button>
                    </div>
                </form>
            </div>
        </div>
    );
};


export default TermsModal;
